import { ProprieteAffichee } from "../proprieteAffichee";
import { RequestStatusType } from "./requestStatusType";


export class RequestProcessing {
  siteId: number;
  guidProcess: string;
  uuid: string;
  imageCount:number;
  startedBy: string;
  duration:number;
  startedAt: Date;
  completedAt: Date;
  status: RequestStatusType;


  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('started_date', 'GEODATA.STARTED_DATE'));
    tab.push(new ProprieteAffichee('duration', 'GLOBAL.DURATION'));
    tab.push(new ProprieteAffichee('nbPics', 'GEODATA.NB_PICTURES'));
    tab.push(new ProprieteAffichee('started_by', 'GEODATA.STARTED_BY'));
    tab.push(new ProprieteAffichee('status', 'GLOBAL.STATUS'));
    tab.push(new ProprieteAffichee('delete', 'GLOBAL.SUPPRIMER'));
    return tab;
  }

  getProprietesAfficheesUploadImage() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('file_name', 'GLOBAL.FILE_NAME'));
    tab.push(new ProprieteAffichee('file_size', 'GLOBAL.FILE_SIZE'));
    tab.push(new ProprieteAffichee('modified', 'GLOBAL.MODIFIED'));
    return tab;
  }

}


